import React from 'react';
import PropTypes from 'prop-types';

import { Form } from 'react-bootstrap';
import Select from 'react-select';

import { ATTRIBUTES_SECTIONS } from 'lib/networking/endpoints';
import {
  l0BeverageCategoryId,
  l0FoodCategoryId,
  l0OperationalsCategoryId,
} from 'lib/enums/TaxonomyLevel';
import pointerOnHover from 'lib/css/pointerOnHover';
import useGet from 'lib/hooks/useGet';

function AttributeScoringRow({ scoreRecords, onUpdate, handleSectionUpdate, isEditing, sections }) {
  const rowData = {
    sectionName: scoreRecords[0]?.attribute_section,
    sectionId: scoreRecords[0]?.attribute_section_id,
    FdScore: scoreRecords
      ?.filter(rec => rec.l0_category_id === l0FoodCategoryId)
      .map(rec => rec.max_score),
    BevScore: scoreRecords
      ?.filter(rec => rec.l0_category_id === l0BeverageCategoryId)
      .map(rec => rec.max_score),
    OpsScore: scoreRecords
      ?.filter(rec => rec.l0_category_id === l0OperationalsCategoryId)
      .map(rec => rec.max_score),
  };

  return (
    <tr className={pointerOnHover}>
      <td>
        {rowData.sectionId === -1 ? (
          <Select
            value={rowData.sectionName}
            options={sections.map(section => ({
              label: section.attribute_section_name,
              value: section.id,
            }))}
            onChange={e => handleSectionUpdate(e)}
            isSearchable
            isClearable
          />
        ) : (
          rowData.sectionName
        )}
      </td>
      <td>
        <Form.Control
          type="number"
          value={rowData.FdScore}
          onChange={e => onUpdate(l0FoodCategoryId, rowData.sectionId, e.target.value)}
          disabled={rowData.sectionId === -1 || !isEditing}
        />
      </td>
      <td>
        <Form.Control
          type="number"
          value={rowData.BevScore}
          onChange={e => onUpdate(l0BeverageCategoryId, rowData.sectionId, e.target.value)}
          disabled={rowData.sectionId === -1 || !isEditing}
        />
      </td>
      <td>
        <Form.Control
          type="number"
          value={rowData.OpsScore}
          onChange={e => onUpdate(l0OperationalsCategoryId, rowData.sectionId, e.target.value)}
          disabled={rowData.sectionId === -1 || !isEditing}
        />
      </td>
    </tr>
  );
}

AttributeScoringRow.propTypes = {
  scoreRecords: PropTypes.array.isRequired,
  onUpdate: PropTypes.func.isRequired,
  handleSectionUpdate: PropTypes.func.isRequired,
  isEditing: PropTypes.bool.isRequired,
  sections: PropTypes.array.isRequired,
};

export default AttributeScoringRow;
